<template>
    <!-- <div class="card overflow-hidden"> -->
    <div class="card border-0">
        <!-- 
            {{ taskOptions }}
        {{ $store.state.project.ProjectFilterList }} 
        -->
        <div class="sectionclsbodymain tsk_body_right_back">
            <div class="serach_controls_main tsk_controls_main_cls">
                <div class="serach_controls_main_row1">
                    <div class="tsk_top_filter_left">
                        <div class="serach_controlsx w-200 me-2">                    
                            <Multiselect 
                                v-model="filterProjectIds" 
                                mode="multiple" 
                                :hide-selected="false" 
                                :caret="true" 
                                :searchable="true" 
                                :create-option="true" 
                                :options="$store.state.project.ProjectFilterList" 
                                placeholder="Select Projects" 
                                v-bind:name="'filterProjectIds[]'" 
                                v-bind:id="'filterProjectIds'"
                                @change="myChangeProjectEvent($event)"  />                                    
                        </div>
                        <div class="serach_controlsx w-200 me-2">                    
                                <Multiselect 
                                    v-model="filterTaskIds" 
                                    mode="multiple" 
                                    :hide-selected="false" 
                                    :caret="true" 
                                    :searchable="true" 
                                    :create-option="true" 
                                    :options="taskOptions" 
                                    placeholder="Select Task" 
                                    v-bind:name="'filterTaskIds[]'" 
                                    v-bind:id="'filterTaskIds'"
                                    @change="myChangeTaskEvent($event)"  />                                    
                            </div>
                        <div class="serach_controlsx w-200">   
                            <Multiselect
                                v-model="filterUsersIds"
                                :caret="true" 
                                mode="multiple"
                                placeholder="Select Teams"
                                :searchable="true"
                                v-bind:name="'filterUsersIds[]'"
                                v-bind:id="'filterUsersIds'" 
                                track-by="label"
                                label='label'
                                :close-on-select="false"
                                @change="myChangeUsersEvent($event)"
                                :hide-selected="false"
                                :options="$store.state.teamMember.TeamMemberImgFilterList"
                            >
                                <template v-slot:tag="{ option, handleTagRemove, disabled }">
                                <div
                                    class="multiselect-tag is-user"
                                    :class="{
                                        'is-disabled': disabled
                                    }"
                                >
                                    <div v-if="option.initials == null">  
                                        <img :src="img_url + '' + option.user_image">
                                        {{ option.label }}
                                    </div>
                                    <div v-else>  
                                        {{ option.initials }} {{ option.label }}
                                    </div>
                                    <span
                                    v-if="!disabled"
                                    class="multiselect-tag-remove"
                                    @mousedown.prevent="handleTagRemove(option, $event)"
                                    >
                                    <span class="multiselect-tag-remove-icon"></span>
                                    </span>
                                </div>
                                </template>
                                <template v-slot:option="{ option }">
                                    <div v-if="option.initials == null">  
                                        <img class="user-image" :src="img_url + '' + option.user_image" >  {{ option.label }}
                                    </div>
                                    <div v-else>
                                        <span class="empIniName">
                                            {{ option.initials }} 
                                        </span>
                                        {{ option.label }}
                                    </div>
                            </template>
                        </Multiselect>                 
                        </div>
                        <div class="serach_controlsx w-200">   
                            <div class="date-range-picker event-filter-options" v-if="opened"
                            v-click-outside="() => (opened = false)">
                                <date-picker 
                                    :showHelperButtons="showHelperButtons" 
                                    :format="format" 
                                    @date-applied="dateApplied"
                                    :same-date-format="sameDateFormat" 
                                    @on-reset="datePickerReset" 
                                    :dateInput="dateInputConfig"
                                    :initialDates="setInitialDates" 
                                    @datepicker-opened="datePickerOpen" 
                                    :max-date="today"
                                />
                            </div>
                            <input type="hidden" class="startDate" id="startDate" name="startDate" v-bind:value="startDate">
                            <input type="hidden" class="endDate" id="endDate" name="endDate" v-bind:value="endDate">
                        </div>
                    </div>  
                </div>
            </div>
        </div>
        <div class="card-body py-0">
            <ul class="notilinkCls notification_main_cls shimmer-wrapper" id="dropdownMenuForNotification" aria-labelledby="dropdownMenuLinkForNotification" v-if="$store.state.notification.notiFormLoader === 1">
                <li class="border-success notification_card mb-2 flex-column" v-for="index in 8" :key="index">
                    <div class="notification_card_header w-100">
                        <div class="notification_card_left w-75">
                            <div class="mg-item-noti_thumb">
                                <div class="mg-thumbnail shimmer-line shimmer-line-br shimmer-line-wd shimmer-animate"></div>                              
                            </div>
                            <div class="notiTitle shimmer-line shimmer-line-br shimmer-line-w40 shimmer-animate ml-2"></div>
                        </div>
                        <div class="notification_card_right w-25">
                            <div class="notiDateTime shimmer-line shimmer-line-br shimmer-line-w30 shimmer-animate float-right"></div>
                        </div>  
                    </div>       
                    <div class="notiMsg_body w-100">
                        <div class="notiMsg mb-2 shimmer-line shimmer-line-br shimmer-line-full shimmer-animate"></div>
                        <div class="notiTaskTitle mb-2 shimmer-line shimmer-line-br shimmer-line-w40 shimmer-animate"></div>
                        <div class="notiTaskTitle mb-2 shimmer-line shimmer-line-br shimmer-line-w60 shimmer-animate"> </div>
                        <div class="notiProTitle shimmer-line shimmer-line-br shimmer-line-w80 shimmer-animate"></div>
                    </div>                
                </li>
            </ul>
            <ul class="notilinkCls notification_main_cls" id="dropdownMenuForNotification" aria-labelledby="dropdownMenuLinkForNotification" v-else-if="$store.state.notification.notiFormLoader === 2">
                <li class="notilinkCls" >
                    <ComponentNoData />
                </li>
            </ul>
            <ul class="notilinkCls notification_main_cls" id="dropdownMenuForNotification" aria-labelledby="dropdownMenuLinkForNotification" v-else>
                <li class="border-success notification_card card mb-2" v-for="(item) in $store.state.notification.notiData" :key="item._id">
                    <div class="notification_card_header">
                        <div class="notification_card_left">
                            <div class="mg-item-noti_thumb">
                                <div class="mg-thumbnail" v-if="item.initials == null">
                                    <img v-bind:src="img_url + '' + item.user_image" v-bind:alt="item.name" v-bind:title="item.name"/>
                                </div>
                                <div class="mg-thumbnail" v-else>
                                    <span v-bind:title="item.name">{{ item.initials }}</span>
                                </div>
                            </div>
                            <div class="notiTitle">
                                {{ item.name }}
                            </div>
                        </div>
                        <div class="notification_card_right">
                            <div class="notiDateTime" v-b-tooltip.hover v-bind:title="dateChangeFormat(item.createdAt)">
                                <timeago :datetime="item.createdAt"/> 
                            </div>
                        </div>  
                    </div>
                    <div class="notiMsg_body">
                        <div class="notiMsg" >
                            {{ item.message }}
                        </div>
                        <div class="notiTaskTitle" v-if="item.task_no != ''">
                            <span>Ticket: </span> #{{ item.task_no }}
                        </div>
                        <div class="notiTaskTitle"  v-if="item.task_title != ''">
                            <!-- <span>Task: </span>{{ item.task_title }} -->
                            <span>Task: </span><router-link :to="`/tasks-kanban?id=${item.task_id}`" class="" exact>
                                    {{ item.task_title }}
                                </router-link>
                        </div>
                        <div class="notiProTitle" >
                            <!-- <span>Project: </span><router-link :to="`/project/${item.project_id}/overview`" class="" exact> -->
                            <span>Project: </span><router-link :to="`/project/${item.project_id}/task-list`" class="" exact>
                                    {{ item.project_title }}
                                </router-link>
                            
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="d-flex px-3 databottom justify-content-between align-content-center" v-if="$store.state.notification.notiFormLoader === 3">
            <p v-if="page * pageLength > $store.state.notification.totalRecord">Showing {{ formatMoney((page * pageLength) - pageLength + 1) }} to {{
                formatMoney($store.state.notification.totalRecord) }} of {{ formatMoney($store.state.notification.totalRecord) }} entries</p>
            <p v-else>Showing {{ formatMoney((page * pageLength) - pageLength + 1) }} to {{ formatMoney(page * pageLength) }} of {{
                formatMoney($store.state.notification.totalRecord) }} entries</p>
            <vs-pagination :total="$store.state.notification.totalLenght" :max="8" v-model="page" @click="reloadPagination(page)"></vs-pagination>
        </div>
    </div>
    <TeamMemberData />
    <ProjectData />
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import Multiselect from '@vueform/multiselect'
import ProjectData from '../components/Projects/ProjectData.vue'
import $ from "jquery";
import ComponentNoData from '@/components/Widgets/Icon/ComponentNoData.vue';
import TeamMemberData from '../components/TeamMember/TeamMemberData.vue'
// import ComponentLoader from '@/components/Widgets/Icon/ComponentLoader'
import { DatePicker } from 'vue-time-date-range-picker';
import 'vue-time-date-range-picker/dist/style.css'
import {
    formatMoney
} from '../helper'

export default {
    name: 'NotificationsPage',
    components: {
        Multiselect,
        ProjectData,
        ComponentNoData,
        DatePicker,
        TeamMemberData,
        // ComponentLoader,
        
    },
    data() {
        return {
            img_url: process.env.VUE_APP_IMG_URL,
            notiCntData: 0,
            notiFormLoader: 1,
            notiData: [],
            notiIdData: [],
            filterProjectIds: [],
            filterTaskIds: [],
            filterUsersIds: [],
            taskOptions: [],
            page: 1,
            // pageLength: this.$store.state.showEntries,
            pageLength: 16,
            totalLenght: 0,
            totalRecord: 0,
            dateRange: null, 
            locale: 'en',
            opened: true,
            showHelperButtons: true,
            format: 'MM-DD-YYYY',
            sameDateFormat: {
                from: 'MM-DD-YYYY',
                to: 'MM-DD-YYYY'
            },
            dateInputConfig: {
                id: 'eventsDateRangeFilter',
                placeholder: 'Select Date',
            },
            setInitialDates: [new Date(this.$store.state.notificationStartDate), new Date(this.$store.state.notificationEndDate)],
            startDate: this.dateFm(new Date(this.$store.state.notificationStartDate)),
            endDate: this.dateFm(new Date(this.$store.state.notificationEndDate)),
        }
    },
    mounted() {
        const bHeight = $('body').height();
        $('#content').addClass('firstHeightCls')
        $('.firstHeightCls').height(bHeight-23) 
        this.$store.state.pageTitle = 'Notifications' 
        $('.card-body ').css('height',this.$store.state.cntSubvar);
        this.getNotifications();
        this.taskDataList();
        this.onResize();
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        startLoader() {
            this.$Progress.start()
        },
        finishLoader() {
            this.$Progress.finish()
        },
        formatMoney,
        checkHeightScroll() {
            $('.table').removeClass('ScrollAddedCls');
            if (this.hasScrollBar() == true) {
                $('.table').addClass('ScrollAddedCls');
            }
        },
        hasScrollBar() {
            if ($(".tbodyCls")[0]) {
                return $('.tbodyCls').get(0).scrollHeight > $('.tbodyCls').height() + 10;
            } else {
                return false;
            }
        },
        onResize() {
            this.windowWidth = window.innerWidth
            this.windowHeight = window.innerHeight

            var headNavCls = $('.headNavCls').outerHeight() || 0;
            // var tsk_tabs = $('.tsk_tabs').outerHeight() || 0;
            // var tsk_controls_main_cls = $('.tsk_controls_main_cls').outerHeight() || 0;
            // var thead = $('thead').outerHeight() || 0;
            // var databottom = $('.databottom').outerHeight() || 0;


            var sectionclsbodymain = $('.sectionclsbodymain').outerHeight() || 0;
            var newVari = sectionclsbodymain + headNavCls;
            // var cntSubvar = headNavCls + tsk_tabs + tsk_controls_main_cls + thead + databottom

            var cntSubvar = this.windowHeight - newVari - 90

            // $('.notilinkCls').height(cntSubvar);
            this.$store.state.cntSubvar = cntSubvar;
            $('.card-body ').css('height',this.$store.state.cntSubvar);
            this.checkHeightScroll();

        },
        myChangeProjectEvent(val) {
            this.filterProjectIds = val
            this.getNotifications();
            this.taskDataList();
        },
        myChangeTaskEvent(val) {
            this.filterTaskIds = val
            this.getNotifications();
        },
        myChangeUsersEvent(val) {
            this.filterUsersIds = val
            this.getNotifications();
        },
        notificationIds(id) {
            return this.notiIdData.push(id);
        },
        dateChangeFormat(dateVal) {
            return moment(dateVal).format('DD-MM-YYYY hh:mm A');
        },
        async reloadPagination(itemObjKey) {
            if (itemObjKey > 0 && itemObjKey !== -1 && itemObjKey <= this.totalLenght) {
                this.page = itemObjKey;
                this.getNotifications();
            }
        },
        async getNotifications() {
            if (this.$store.state.notification.notiData.length > 0) {
                // this.$store.state.notification.notiFormLoader = 1

            }else{
                this.$store.state.notification.notiFormLoader = 1
            }
            this.startLoader()
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
            await axios.get(process.env.VUE_APP_API_URL + 'dashboard/get-notifications', {
                params: {
                    page: this.page,
                    pageLength: this.pageLength,
                    project_id: this.filterProjectIds,
                    task_id: this.filterTaskIds,
                    user_id: this.filterUsersIds,
                    startDate: this.startDate,
                    endDate: this.endDate
                }
            })
            .then((resp) => {
                if (resp.status == 200 && resp.data.status == 'success') {
                    
                    this.notiData = resp.data.data.records
                    this.notiCntData = resp.data.data.length
                    this.totalRecord = resp.data.data.totalRecord
                    this.totalLenght = this.totalRecord / this.pageLength
                    this.totalLenght = Math.ceil(this.totalLenght);
                    
                    this.$store.state.notification.notiData = this.notiData
                    this.$store.state.notification.totalRecord = this.totalRecord
                    this.$store.state.notification.totalLenght = this.totalLenght

                    if (this.$store.state.notification.notiData.length > 0) {
                        this.$store.state.notification.notiFormLoader = 3
                    } else {
                        this.$store.state.notification.notiFormLoader = 2
                    }
                    this.finishLoader()
                    setTimeout(async () =>
                        this.onResize(),
                    300);
                }
            })
            .catch(error => {
                // this.errorMessage = error.message;
                console.error("There was an error!", error);
                console.log("response", error.response.status);
                console.log("message", error.response.data.message);
                this.$store.state.notification.notiFormLoader = 1
                // this.errorRes = error.response.data.message;
            })
        },
        async taskDataList() {
            this.startLoader()
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
            await axios.get(process.env.VUE_APP_API_URL + 'task/active-task-list', {
                params: {
                    project_id: this.filterProjectIds,
                }
            })
            .then((resp) => {
                if (resp.status == 200 && resp.data.status == 'success') {
                    const taskOpts = resp.data.data.records
                    this.taskOptions = [];
                    var len = taskOpts.length;
                    for (var i = 0; i < len; i++) {
                        this.taskOptions.push({
                            value: taskOpts[i]._id,
                            label: taskOpts[i].title+' ( #'+ taskOpts[i].task_no +')'
                        });
                    }
                }
                this.finishLoader()
            })
            .catch(error => {
                console.error("There was an error!", error);
                console.log("response", error.response.status);
                console.log("message", error.response.data.message);
            })
        },
        datePickerReset() {
                document.getElementsByClassName("vdpr-datepicker__calendar-dialog")[0].style.display = "none"
                document.body.classList.remove('date-picker-open')
            },
        dateApplied(date1, date2) {
            const today = new Date();
            if (new Date(date1) > today || new Date(date2) > today) {
                document.getElementsByClassName("vdpr-datepicker__calendar-dialog")[0].style.display = "none"
                document.body.classList.remove('date-picker-open')
                return false
            }
            document.getElementsByClassName("vdpr-datepicker")[0].getElementsByTagName('input')[0].style.width = '225px'
            this.notificationStartDate = moment(date1).format('YYYY-MM-DD')
            this.notificationEndDate = moment(date2).format('YYYY-MM-DD')
            this.startDate = this.notificationStartDate;
            this.endDate = this.notificationEndDate;
            $('.startDate').val(this.notificationStartDate)
            $('.endDate').val(this.notificationEndDate)
            document.body.classList.remove('date-picker-open')
            this.$store.state.notificationStartDate = date1
            this.$store.state.notificationEndDate = date2
            this.page = 1;
            this.getNotifications();
            $('#eventsDateRangeFilter').val(moment(date1).format('DD-MM-YYYY')+' - '+moment(date2).format('DD-MM-YYYY'))
            
        },
        datePickerOpen: function () {
            document.body.classList.add("date-picker-open");
        },
        dateFm(date) {
            let today = new Date(date);
            let day = String(today.getDate()).padStart(2, '0');
            let month = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            let year = today.getFullYear();
            return `${year}-${month}-${day}`;
        },
    },
    directives: {
            'click-outside': {
                beforeMount: function (el, binding, vnode) {
                    // this.binding = binding;
                    // this.vnode = vnode;
                    console.log(binding);
                    console.log(vnode);
                    console.clear();
                    el.clickOutsideEvent = evt => {
                        evt.stopPropagation()
                        if (!(el === evt.target || el.contains(evt.target))) {
                            let bl = !$(".vdpr-datepicker__calendar-dialog").is(":visible");
                            if (bl == false) {
                                $('#eventsDateRangeFilter').trigger('click');
                            }
                        }
                    }
                    window.requestAnimationFrame(() => {
                        document.addEventListener('click', el.clickOutsideEvent)
                    })
                },
                unmounted(el) {
                    document.removeEventListener('click', el.clickOutsideEvent)
                },
            }
        },
}
</script>
<style scoped>
.notilinkCls{
    overflow: auto;
}
</style>